import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-action-button',
  templateUrl: './action-button.component.html',
  styleUrls: ['./action-button.component.scss'], // Corrected: `styleUrl` -> `styleUrls`
})
export class ActionButtonComponent {
  @Input() image: string = '../../../../assets/icons/add-circle.svg';
}
